export default function Hr({ borderColor = "gray", opacity = "20" }) {
    return (
        <hr className={`border border-solid border-${borderColor} opacity-${opacity} my-5`} />
    )
};